module.exports = __webpack_public_path__ + "static/img/hj_tg.6c40735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hj_tg.jpg
// module id = CdLp
// module chunks = 2